// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__EfKGr","jpCurrentDate":"JP_Footer_jpCurrentDate__n7klW","jpFootage":"JP_Footer_jpFootage__ni+cy","higlight":"JP_Footer_higlight__Gb13D"};